module.exports = __webpack_public_path__ + "static/media/blackHome.b2cd8cfe.svg";